<template>
  <div class="openOrder_order"> 
    <div class="back" @click="back">
      <van-icon name="arrow-left" />
    </div>
    <!-- 批次列表 -->
    <!-- <div class="order_list">
      <van-tabs ref="ref_tab_order" v-model="order_active_index" line-height="0" :border="false" background="transparent" @change="changeOrder">
        <van-tab v-for="(item,index) in order_list" :key="index" :name="index">
          <template #title>
            <div class="order_name van-ellipsis">订单{{item.order_number}}</div>
          </template>
        </van-tab>
      </van-tabs>
    </div> -->

    <div class="all_shop_box">
      <!-- 单个购物车 -->
      <div class="item_shop_box" v-for="(item_box,index_box) in order_list" :key="index_box" v-show="index_box == order_active_index">
        <!-- 购物车box -->
        <div class="shop_box">
          <div
            class="shop_good checked"
            v-for="(item_good,index_good) in item_box.order_goods"
            :key="index_good"
          >
            <!-- 商品名字和金额 -->
            <div v-if="item_good.goods_type != 2">
              <div class="shop_good_name_price">
                <div class>{{item_good.name}}</div>
                <div v-if="item_good.bale == 1">￥{{(item_good.price * item_good.num).toFixed(2)}}</div>
                <div v-else>￥{{(item_good.price * item_good.weight).toFixed(2)}}</div>
              </div>
              <!-- 商品规格和数量 -->
              <div class="shop_good_type_num">
                <div class>
                  <div class="good_type good_type_0" v-if="item_good.bale == 3">
                    散装
                    <img src="./../../../assets/img/work/open_order/order/type_sanzhuang.png" alt />
                  </div>
                  <div class="good_type good_type_1" v-if="item_good.bale == 1">
                    定装
                    <img src="./../../../assets/img/work/open_order/order/type_dingzhuang.png" alt />
                  </div>
                  <div class="good_type good_type_2" v-if="item_good.bale == 2">
                    非定装
                    <img src="./../../../assets/img/work/open_order/order/type_feidingzhuang.png" alt />
                  </div>
                </div>
                <div v-if="item_good.bale == 1">{{item_good.num}}{{unit_list[item_good.num_unit-1].name}}x{{item_good.price}}元/{{unit_list[item_good.num_unit-1].name}}</div>
                <div v-else>{{Number(item_good.weight).toFixed(3)}}公斤x{{item_good.price}}元/公斤</div>
              </div>
            </div>
            <!-- 附加费 -->
            <div v-else>
              <div class="shop_good_name_price">
                <div class>{{item_good.name}}</div>
                <div >￥{{(item_good.price * item_good.num).toFixed(2)}}</div>
              </div>
              <!-- 商品规格和数量 -->
              <div class="shop_good_type_num">
                <div class>
                </div>
                <div>{{item_good.price}}{{item_good.type == 1?'元/份':'元'}} {{item_good.type == 1?" x "+(item_good.num-0)+'份':''}} </div>
              </div>
            </div>
            <div class="shop_good_close" @click="clearGoods(index_box,index_good)">
              <van-icon name="cross" size="0.24rem" />
            </div>
          </div>
        </div>
        <!-- 添加货品 -->
        <div class="add_shop_good" @click="addGoods">
          <van-icon name="plus" size="0.36rem" />
          <span style="margin-left:0.1rem">添加商品</span>
        </div>
      </div>
    </div>

    <!-- 底部结算栏 -->
    <div style="height:1.4rem"></div>
    <div class="order_footer" :disabled="total_goods_num==0">
      <div>
        <span>
          总计：
          <span class="color_theme">￥{{total_goods_amount}}</span>
        </span>
        <span>
          已选：
          <span class="color_theme">{{total_goods_num}}</span> 种
        </span>
      </div>
      <div class @click="total_goods_num>0?onSubmit():''">结算</div>
    </div>
  </div>
</template>

<script>
import Cookies from '@/utils/Cookies'
export default {
  name: "openOrder_order",
  data() {
    return {
      unit_list:[{value:1,name:'件'},{value:2,name:'包'},{value:3,name:'袋'},{value:4,name:'盒'},{value:5,name:'瓶'},{value:6,name:'箱'},{value:7,name:'罐'}],
      order_active_index: 0,
      order_total_num: 1, // 订单序号
      order_list: [
        {
          order_number: "0001",
          order_sn:'',
          order_goods: []
        }
      ],

      total_goods_num:0,
      total_goods_amount:0.00,
      detailData:{}
    };
  },
  created() {
    this.order_list[0].order_sn = this.$route.query.order_sn
    this.detailData = JSON.parse(decodeURI(this.$route.query.detailData))
    this.order_list[0].order_goods = this.detailData.goods
    this.computeTotal()
    this.$navigation.on('back', (to, from) => {
      if(from.route.name == 'openOrder_changeGoods'){
        if(from.route.meta.backData){
          this.order_list[0].order_goods.push(JSON.parse(from.route.meta.backData))
          delete from.route.meta.backData
          this.computeTotal()
        }
      }
      if(from.route.name == 'openOrder_selectBatch'){
        if(from.route.meta.backData){
          this.order_list[0].order_goods.push(JSON.parse(from.route.meta.backData))
          delete from.route.meta.backData
          this.computeTotal()
        }
      }
    })
  },
  mounted() {},
  methods: {
    // 结账
    onSubmit(){
      this.computeTotal()
      var buyer = {buyer_id:this.detailData.buyer_id,buyer_name:this.detailData.buyer_name}
      this.$router.push({
        path: "/openOrder/orderPay",
        query:{
          amount:this.total_goods_amount,
          order_sn:this.order_list[0].order_sn,
          order_list:encodeURI(JSON.stringify(this.order_list)),
          buyer:encodeURI(JSON.stringify(buyer))
        }
      });
    },

    // 计算总价
    computeTotal(){
      var goods = this.order_list[0].order_goods
      var amount = 0;
      for (let i = 0; i < goods.length; i++) {
        const item = goods[i];
        if(item.goods_type== 1){
          if(item.bale == 1){
            amount += item.price * item.num
          }else{
            amount += item.price * item.weight
          }
        }else if (item.goods_type == 2){
          amount += item.price * item.num
        }
      }
      this.total_goods_num = goods.length
      this.total_goods_amount = amount.toFixed(2)
    },


    // 删除一件商品
    clearGoods(i,i_g){
      this.order_list[i].order_goods.splice(i_g,1)
      this.computeTotal()
    },


    // 去选择商品
    addGoods(){
      this.$router.push({
        path: "/openOrder/selectBatch"
      });
    },

    // 返回
    back(){
      this.$dialog
        .confirm({
          title: "改单信息还未提交",
          message: "确认离开吗？"
        })
        .then(() => {
          this.$router.go(-1)
        }).catch(() => {
          // on cancel
        });
    }

  },
};
</script>

<style lang="less" scoped>
.openOrder_order {
  position: relative;
  .back{
    background-color: #fff;
    height: 0.88rem;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 11;
    font-size: 0.36rem;
    padding: 0 0.2rem;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
  .order_add_box{
    position: fixed;
    height: 0.88rem;
    // line-height: 0.88rem;
    text-align: center;
    right: 0.3rem;
    top: 0;
    z-index: 10;
    font-size: 0.30rem;
    font-weight: 500;
    color: #333;
    display: flex;
    align-items: center;
    justify-content: space-between;
    &>div{
      padding:0 0.2rem;
      line-height: 0.54rem;
      border:0.01rem solid #31b158;
      border-radius: 0.28rem;
      background-color: #31b158;
      color: #fff;
    }
  }
  .order_list {
    position: sticky;
    z-index: 2;
    top: 0.88rem;
    width: 100%;
    height: 1.72rem;
    padding-top: 0.72rem;
    background: linear-gradient(-90deg, #25a94d, #3fbe66);
    box-sizing: border-box;
    overflow: hidden;
    .order_items {
      width: 5.6rem;
      height: 1rem;
      white-space: nowrap;
      overflow-y: hidden;
      overflow-x: auto;
      &::before {
        content: ".";
        display: block;
        height: 0;
        visibility: hidden;
      }
      .order_item {
        line-height: 1rem;
        margin-right: 0.16rem;
        &:nth-child(1) {
          margin-left: 0.3rem;
        }
      }
    }
  }

  // 中间模块
  .shop_box {
    padding: 0.3rem 0.2rem 0;
    .shop_good {
      width: 6.9rem;
      margin: 0 auto 0.2rem;
      height: 1.5rem;
      border-radius: 0.1rem;
      background-color: #fff;
      border: 0.02rem solid #fff;
      overflow: hidden;
      position: relative;
      padding: 0 0.3rem;
      box-sizing: border-box;
      &.checked {
        border: 0.02rem solid #31b158;
        .shop_good_close {
          display: flex;
        }
      }
      .shop_good_name_price,
      .shop_good_type_num {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      .shop_good_name_price {
        font-size: 0.36rem;
        color: #333;
        font-weight: bold;
        margin-top: 0.24rem;
      }
      .shop_good_type_num {
        font-size: 0.28rem;
        color: #666;
        margin-top: 0.12rem;
        .good_type {
          padding: 0 0.18rem;
          height: 0.4rem;
          line-height: 0.4rem;
          border-radius: 0.2rem;
          &.good_type_0 {
            background-color: #dafbdb;
            color: #4b9c64;
          }
          &.good_type_1 {
            background-color: #daeffb;
            color: #1d78c5;
          }
          &.good_type_2 {
            background-color: #fbedda;
            color: #bf8535;
          }
          img {
            width: 0.22rem;
            height: 0.22rem;
            margin-left: 0.1rem;
          }
        }
      }

      .shop_good_close {
        position: absolute;
        right: 0;
        top: 0;
        width: 0.28rem;
        height: 0.28rem;
        background-color: #31b158;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        display: none;
      }
    }
  }
  // 添加货品
  .add_shop_good {
    width: 6.9rem;
    margin: 0 auto 0.2rem;
    height: 1.5rem;
    border-radius: 0.1rem;
    background-color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 0.36rem;
    color: #31b158;
    font-weight: bold;
  }

  // 删除订单
  .romove_shop{
    background-color: #fb8a8a;
    width: 6.9rem;
    border-radius: 0.1rem;
    height: 0.8rem;
    margin: 0 auto 0.2rem;
    margin-top: 0.6rem;
    font-size: 0.36rem;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  // 底部
  .order_footer {
    width: 100%;
    height: 1.4rem;
    position: fixed;
    bottom: 0;
    left: 0;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-shadow: 0rem -0.1rem 0.2rem 0.05rem rgba(191, 191, 191, 0.1);
    &[disabled] {
      & > div:nth-child(1) {
        & > span {
          color: #b3b3b3 !important;
          .color_theme {
            color: #b3b3b3 !important;
          }
        }
      }
      & > div:nth-child(2) {
        background-color: #b3b3b3;
      }
    }
    & > div:nth-child(1) {
      & > span {
        display: block;
        margin-left: 0.5rem;
        font-size: 0.36rem;
        color: #333;
        font-weight: bold;
        &:nth-child(2) {
          margin-top: 0.1rem;
          font-size: 0.28rem;
        }
        .color_theme {
          color: #31b158;
          font-size: 0.36rem;
        }
      }
    }
    & > div:nth-child(2) {
      width: 2.2rem;
      height: 1.4rem;
      background-color: #f3a427;
      color: #fff;
      font-size: 0.48rem;
      line-height: 1.4rem;
      text-align: center;
      font-weight: bold;
    }
  }
}
</style>

<style lang="less">
.openOrder_order{
  .van-tabs{
      width: 100%;
      // padding-right: 1.9rem ;
      height: 1rem;
      .van-tabs__wrap{
        height: 1rem;
        line-height: 1rem;
        .van-tabs__nav{
          box-sizing:border-box;
          .van-tab{
            box-sizing: border-box;
            width: 1.6rem;
            min-width: 1.6rem;
            height: 1rem;
            background: rgba(255, 255, 255, 0.3);
            border-radius: 0.1rem 0.1rem 0px 0px;
            font-size: 0.32rem;
            color: #fff;
            padding: 0 0.1rem;
            line-height: 1rem;
            margin-right: 0.2rem;
            flex: inherit;
            &:nth-child(1){
              margin-left: 0.2rem;
            }
            .order_num {
              font-size: 0.28rem;
              line-height: 0.38rem;
            }
            .order_name {
              font-weight: bold;
              letter-spacing: -0.01rem;
            }
            &--active {
              background: #f5f5f5;
              color: #333;
              .order_num {
                color: #999999;
              }
            }
          }
        }
      }
      .van-tab:last-child{
        font-size: 0.6rem;
        margin-right: 1rem;
      }
  }
}
</style>